import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import useSharedStyles from './theme/pbdqShared.styles';
import { pbdqFont } from './theme/pbdqTokens';
import { sdsColors, sdsRadius, sdsBtnBase } from './theme/solutionsDesignSystem';
import pbdqRoutes from './pbdqRoutes';

import PbdqNav from './components/PbdqNav.comp';
import PbdqFooter from './components/PbdqFooter.comp';
import { useAgentChat } from './components/PbdqAgentChatContext';
import PbdqGradientStripe from './components/PbdqGradientStripe.comp';
import PbdqImpactStories from './components/PbdqImpactStories.comp';

import ImpactHero from '../../assets/images/PoweredByDQ/ImpactHero.png';
import ImpactStoryLogoGcf from '../../assets/images/PoweredByDQ/ImpactStoryLogoGcf.png';
import ImpactStoryLogoGyeongsangbukDo from '../../assets/images/PoweredByDQ/ImpactStoryLogoGyeongsangbukDo.png';
import ImpactStoryLogoLego from '../../assets/images/PoweredByDQ/ImpactStoryLogoLego.png';
import ImpactStoryLogoNusCtic from '../../assets/images/PoweredByDQ/ImpactStoryLogoNusCtic.png';
import ImpactStoryLogoTiktok from '../../assets/images/PoweredByDQ/ImpactStoryLogoTiktok.png';
import ImpactStoryLogoEsmart from '../../assets/images/PoweredByDQ/ImpactStoryLogoEsmart.png';
import ImpactStoryLogo2Accenture from '../../assets/images/PoweredByDQ/ImpactStoryLogo2Accenture.png';
import ImpactStoryLogoWorldBank from '../../assets/images/PoweredByDQ/ImpactStoryLogoWorldBank.png';
import ImpactStoryLogo2KyrgyzMoe from '../../assets/images/PoweredByDQ/ImpactStoryLogo2KyrgyzMoe.png';
import HomeStoryImage1 from '../../assets/images/PoweredByDQ/HomeStoryImage1.jpg';
import HomeStoryImage2 from '../../assets/images/PoweredByDQ/HomeStoryImage2.jpg';
import HomeStoryImage3 from '../../assets/images/PoweredByDQ/HomeStoryImage3.jpg';
import HomeStoryImage4 from '../../assets/images/PoweredByDQ/HomeStoryImage4.jpg';
import HomeStoryImage5 from '../../assets/images/PoweredByDQ/HomeStoryImage5.jpg';
import HomeStoryImage6 from '../../assets/images/PoweredByDQ/HomeStoryImage6.jpg';
import HomeStoryImage7 from '../../assets/images/PoweredByDQ/HomeStoryImage7.jpg';
import HomeStoryImage8 from '../../assets/images/PoweredByDQ/HomeStoryImage8.jpg';
import ImpactStoryLogoUaeMoe from '../../assets/images/PoweredByDQ/ImpactStoryLogoUaeMoe.png';

const useStyles = makeStyles(() => ({
    heroSection: {
        background: 'radial-gradient(70% 90% at 86% 10%, #DCE7F3 0%, rgba(220, 231, 243, 0) 60%), linear-gradient(180deg, #F6F8FB 0%, #FFFFFF 100%)',
    },
    heroInner: {
        maxWidth: 1320,
        margin: '0 auto',
        padding: 'clamp(36px, 4.5vw, 64px) clamp(20px, 4vw, 56px) clamp(40px, 5vw, 64px)',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '24px clamp(32px, 5vw, 80px)',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
    },
    heroContent: {
        flex: '1 1 440px',
        minWidth: 0,
        display: 'grid',
        gap: 20,
        alignContent: 'start',
    },
    heroTitle: {
        fontSize: 'clamp(36px, 4.2vw, 60px)',
        lineHeight: 1.04,
        letterSpacing: '-0.03em',
        fontWeight: 800,
        margin: 0,
        maxWidth: '18ch',
        fontFamily: pbdqFont,
        color: '#1B2430',
    },
    heroTitleHighlight: {
        color: '#ED6628',
    },
    heroLead: {
        fontSize: 'clamp(16px, 1.3vw, 18px)',
        lineHeight: 1.55,
        color: '#5B6470',
        margin: 0,
        maxWidth: '58ch',
        fontFamily: pbdqFont,
    },
    heroArt: {
        flex: '1 1 400px',
        minWidth: 0,
        maxWidth: 640,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '@media (max-width: 820px)': {
            minHeight: 0,
            maxWidth: 'none',
        },
    },
    heroPhotoImg: {
        width: '100%',
        height: 'auto',
        display: 'block',
    },

    statsSection: {
        background: '#FFFFFF',
    },
    statsInner: {
        maxWidth: 1320,
        margin: '0 auto',
        padding: 'clamp(36px, 4.5vw, 56px) clamp(20px, 4vw, 56px)',
        boxSizing: 'border-box',
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        background: '#FFFFFF',
        border: '1px solid #E6E9EE',
        borderRadius: 24,
        overflow: 'hidden',
        boxSizing: 'border-box',
        '@media (max-width: 768px)': {
            gridTemplateColumns: '1fr',
        },
    },
    statCell: {
        position: 'relative',
        padding: '28px clamp(20px, 2.4vw, 32px) 26px',
        display: 'grid',
        gap: 8,
        alignContent: 'start',
        borderRight: '1px solid #E6E9EE',
        borderBottom: '1px solid #E6E9EE',
        margin: '0 -1px -1px 0',
        boxSizing: 'border-box',
    },
    statRail: {
        position: 'absolute',
        top: 0,
        left: 'clamp(20px, 2.4vw, 32px)',
        width: 32,
        height: 5,
        borderRadius: '0 0 4px 4px',
    },
    statValue: {
        fontSize: 'clamp(26px, 2.4vw, 34px)',
        lineHeight: 1.05,
        fontWeight: 800,
        letterSpacing: '-0.03em',
        color: '#C2521A',
        margin: 0,
        fontVariantNumeric: 'tabular-nums',
        fontFamily: pbdqFont,
    },
    statLabel: {
        fontSize: 14,
        lineHeight: 1.45,
        color: '#5B6470',
        margin: 0,
        fontFamily: pbdqFont,
    },

    storiesSection: {
        padding: '48px 0 56px',
        background: sdsColors.surface,
        borderTop: `1px solid ${sdsColors.border}`,
        borderBottom: `1px solid ${sdsColors.border}`,
    },
    sectionHeader: {
        textAlign: 'center',
        marginBottom: 40,
    },
    sectionChip: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '6px 14px',
        borderRadius: sdsRadius.pill,
        background: sdsColors.surface,
        border: `1px solid ${sdsColors.borderWarm}`,
        color: sdsColors.accentDark,
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        marginBottom: 16,
    },
    h2: {
        margin: '0 auto',
        fontSize: 'clamp(28px, 3vw, 36px)',
        fontWeight: 700,
        lineHeight: 1.2,
        color: sdsColors.text,
    },
    lead: {
        margin: '12px auto 0',
        maxWidth: 900,
        fontSize: 18,
        lineHeight: 1.55,
        color: sdsColors.textMuted,
    },

    timelineSection: {
        background: '#FFFFFF',
    },
    timelineInner: {
        maxWidth: 1320,
        margin: '0 auto',
        padding: 'clamp(36px, 4.5vw, 56px) clamp(20px, 4vw, 56px)',
        boxSizing: 'border-box',
    },
    timelineBox: {
        padding: 'clamp(32px, 4vw, 56px) clamp(20px, 3vw, 44px)',
        borderRadius: 24,
        background: '#FBF1EA',
        boxSizing: 'border-box',
    },
    timelineHeader: {
        display: 'grid',
    },
    timelineKicker: {
        display: 'block',
        fontSize: 13,
        lineHeight: 1,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        fontWeight: 700,
        color: '#2A4057',
        marginBottom: 16,
        fontFamily: pbdqFont,
    },
    timelineTitle: {
        fontSize: 'clamp(28px, 3.4vw, 46px)',
        lineHeight: 1.06,
        letterSpacing: '-0.025em',
        fontWeight: 800,
        margin: 0,
        whiteSpace: 'nowrap',
        color: '#1B2430',
        fontFamily: pbdqFont,
        '@media (max-width: 600px)': {
            whiteSpace: 'normal',
        },
    },
    timelineTitleHighlight: {
        color: '#ED6628',
    },
    timelineBodyRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'clamp(28px, 4vw, 64px)',
        alignItems: 'center',
        marginTop: 40,
    },
    timelineList: {
        flex: '1 1 400px',
        minWidth: 0,
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'grid',
    },
    timelineItem: {
        display: 'grid',
        gridTemplateColumns: '20px 1fr',
        gap: 18,
    },
    timelineTrackCol: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 6,
    },
    timelineDot: {
        width: 14,
        height: 14,
        borderRadius: '50%',
        flex: 'none',
        marginTop: 4,
    },
    timelineLine: {
        width: 2,
        flex: 1,
        background: '#E8D9CC',
    },
    timelineItemContent: {
        display: 'grid',
        gap: 6,
    },
    timelineItemDate: {
        fontSize: 13,
        fontWeight: 700,
        color: '#A63C0C',
        fontFamily: pbdqFont,
    },
    timelineItemHeading: {
        fontSize: 20,
        lineHeight: 1.2,
        letterSpacing: '-0.015em',
        fontWeight: 800,
        margin: 0,
        color: '#1B2430',
        fontFamily: pbdqFont,
    },
    timelineItemDesc: {
        fontSize: 15,
        lineHeight: 1.6,
        margin: 0,
        color: '#1B2430',
        fontFamily: pbdqFont,
    },
    timelineItemLead: {
        fontWeight: 700,
    },
    videoFigure: {
        flex: '1 1 360px',
        minWidth: 0,
        margin: 0,
        display: 'grid',
        gap: 12,
    },
    videoWrap: {
        aspectRatio: '16/9',
        position: 'relative',
        borderRadius: 16,
        overflow: 'hidden',
        background: '#172939',
        boxShadow: '0 20px 50px rgba(23, 41, 57, 0.14)',
    },
    videoIframe: {
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        border: 0,
    },
    videoCaption: {
        fontSize: 14,
        lineHeight: 1.6,
        color: '#5B6470',
        fontFamily: pbdqFont,
    },

    ctaSection: {
        marginTop: 'clamp(24px, 3vw, 40px)',
        background: '#172939',
        color: '#FFFFFF',
    },
    ctaInner: {
        maxWidth: 1320,
        margin: '0 auto',
        padding: 'clamp(36px, 4.5vw, 56px) clamp(20px, 4vw, 56px)',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '24px 48px',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
    },
    ctaTitle: {
        fontSize: 'clamp(28px, 3.2vw, 44px)',
        lineHeight: 1.08,
        letterSpacing: '-0.03em',
        fontWeight: 800,
        margin: 0,
        maxWidth: '20ch',
        color: '#FFFFFF',
        fontFamily: pbdqFont,
    },
    ctaBtn: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        height: 54,
        padding: '0 26px',
        borderRadius: 999,
        background: '#ED6628',
        color: '#FFFFFF',
        textDecoration: 'none',
        fontSize: 16,
        fontWeight: 700,
        whiteSpace: 'nowrap',
        fontFamily: pbdqFont,
        transition: 'background 200ms cubic-bezier(.32,.72,0,1)',
        '&:hover': {
            background: '#D5581D',
            color: '#FFFFFF',
            textDecoration: 'none',
        },
    },
}));

const STAT_RAILS = ['#68C3EE', '#BCD253', '#EDB459', '#ED6628', '#B9316D', '#718DC4', '#68C3EE', '#BCD253', '#EDB459'];

const STATS = [
    { value: '15+ yrs', label: 'of dedicated work since 2009' },
    { value: '100+', label: 'countries reached' },
    { value: '100+', label: 'partner organizations' },
    { value: '1.5M+', label: 'children reached via #DQEveryChild' },
    { value: '2.3B+', label: 'estimated media reach' },
    { value: 'IEEE 3527.1', label: 'the global standard, used in 100+ countries' },
    { value: '803,560', label: 'children’s data points in the DQ Index' },
    { value: '21+', label: 'languages of DQ content' },
    { value: '1,000+', label: 'frameworks and programs mapped to DQ' },
];

const STORIES = [
    {
        id: 'gcf',
        sector: 'ngo',
        cats: ['Governments and ministries', 'Frameworks and indices'],
        logo: ImpactStoryLogoGcf,
        logoAlt: 'CPC Index logo',
        hero: HomeStoryImage1,
        heroAlt: 'Global Cybersecurity Forum — Child Online Safety & CPC Index',
        heroFit: 'contain',
        logoScale: 1.35,
        title: 'A global mission to cut child cyber-risk by 15% in five years — measured on Powered by DQ',
        summary: 'Child online safety efforts were fragmented across laws, schools, families, and platforms, with no single benchmark to align a whole nation. The CPC Index and its National Toolkit, built on Powered by DQ, give 100 countries the ability to assess children’s digital skills, measure online risks, create targeted safety programs, and track national progress against a global benchmark.',
        body: 'Child online safety efforts were fragmented across laws, schools, families, and platforms, with no single benchmark to align a whole nation. The CPC Index and its National Toolkit, built on Powered by DQ, give 100 countries the ability to assess children’s digital skills, measure online risks, create targeted safety programs, and track national progress against a global benchmark.',
        quote: {
            text: '[Placeholder — quote from the Global Cybersecurity Forum to be supplied]',
            attribution: 'Global Cybersecurity Forum',
        },
        stats: [
            { value: '100+', label: 'countries covered' },
            { value: '150M+', label: 'children the initiative aims to reach' },
            { value: '−15%', label: 'targeted reduction in child cyber-risk over five years' },
        ],
        builtWith: 'FrameworkCreator · AssessCreator · DQ Stars · DQ Index Connect',
        websiteUrl: 'https://www.spa.gov.sa/ru/N2412817',
    },
    {
        id: 'gyeongsangbuk-do',
        sector: 'gov',
        cats: ['Governments and ministries', 'Frameworks and indices'],
        logo: ImpactStoryLogoGyeongsangbukDo,
        logoAlt: 'Gyeongsangbuk-do Province & DQ Lab logo',
        hero: HomeStoryImage2,
        heroAlt: 'Gyeongsangbuk-do AI literacy standard initiative',
        heroFit: 'contain',
        title: 'Gyeongsangbuk-do built a government-owned AI literacy standard, in time for APEC 2025',
        summary: 'Korea’s largest province deployed all five capabilities — Define, Measure, Build, Validate, Benchmark — as a globally interoperable ecosystem anchored to IEEE 3527.1, owned end-to-end by the government and positioned as a model for other APEC economies.',
        body: 'Korea’s largest province deployed all five capabilities — Define, Measure, Build, Validate, Benchmark — as a globally interoperable ecosystem anchored to IEEE 3527.1, owned end-to-end by the government and positioned as a model for other APEC economies.',
        quote: {
            text: 'In the AI era, digital capability and ethics decide the future of regions and nations, and we will make the most of it to lead the way in solving the world’s digital challenges together with the DQ Institute.',
            attribution: 'Cheol-woo Lee, Governor of Gyeongsangbuk-do',
        },
        stats: [
            { value: '2.6M', label: 'residents served' },
            { value: '5 / 5', label: 'capabilities deployed' },
            { value: '100+', label: 'institutions in the DQ network behind its expansion' },
        ],
        builtWith: 'Workforce AI Readiness · LearnCreator',
        // websiteUrl: 'https://www.gb.go.kr',
        websiteUrl: 'https://www.localnewsroom.co.kr/news/articleView.html?idxno=7363',
    },
    {
        id: 'lego',
        sector: 'corp',
        cats: ['Companies'],
        logo: ImpactStoryLogoLego,
        logoAlt: 'The LEGO Group logo',
        hero: HomeStoryImage3,
        heroAlt: 'LEGO Doom the Gloom digital citizenship experience',
        heroFit: 'contain',
        title: 'LEGO made digital citizenship playful — and won gold for it',
        summary: 'Co-developed by the LEGO Group and DQ Institute, Doom the Gloom used interactive videos, mini-games and LEGO Minifigures to help children explore digital empathy, critical thinking, screen-time management, privacy and cybersecurity. Built around eight competencies from the DQ Framework underpinning IEEE 3527.1, the free experience enabled children to create their own digital hero while learning how to contribute to safer, healthier online communities.',
        body: 'Co-developed by the LEGO Group and DQ Institute, Doom the Gloom used interactive videos, mini-games and LEGO Minifigures to help children explore digital empathy, critical thinking, screen-time management, privacy and cybersecurity. Built around eight competencies from the DQ Framework underpinning IEEE 3527.1, the free experience enabled children to create their own digital hero while learning how to contribute to safer, healthier online communities.',
        quote: {
            text: 'Together we share an ambition to equip children, and also parents, with the knowledge, tools and skills needed to build a generation of responsible digital citizens.',
            attribution: 'Kathrine Kirk Muff, VP of Social Responsibility, The LEGO Group',
        },
        stats: [
            { value: '20 languages', label: 'available to children and families globally' },
            { value: '8 competencies', label: 'from the DQ digital citizenship framework' },
            { value: 'Gold Award', label: '2022 Play for Change Awards — Life Skills' },
        ],
        builtWith: 'DQ Stars · LearnCreator',
        websiteUrl: 'https://www.lego.com/en-us/aboutus/news/2021/october/digital-citizenship',
    },
    {
        id: 'nus-ctic',
        sector: 'edu',
        cats: ['Schools and universities', 'Frameworks and indices'],
        logo: ImpactStoryLogoNusCtic,
        logoAlt: 'NUS Center for Trusted Internet & Community logo',
        hero: HomeStoryImage4,
        logoScale: 1.15,
        heroAlt: 'NUS-CTIC Living Well Digitally indicator framework and assessment',
        heroFit: 'contain',
        title: 'NUS-CTIC made digital wellbeing measurable across everyday life — and assessed 4,000+ people across four cities on it',
        summary: 'There was no common, holistic way to measure how digital life affects people’s everyday wellbeing. Developed by NUS-CTIC, powered by DQ, through two years of research, the Living Well Digitally initiative introduced a Digital Wellbeing Indicator Framework spanning five domains of digital life. Powered by DQ, the framework was transformed into a free assessment that provides individuals with an immediate digital-wellbeing score and practical insights for improvement.',
        body: 'There was no common, holistic way to measure how digital life affects people’s everyday wellbeing. Developed by NUS-CTIC, powered by DQ, through two years of research, the Living Well Digitally initiative introduced a Digital Wellbeing Indicator Framework spanning five domains of digital life. Powered by DQ, the framework was transformed into a free assessment that provides individuals with an immediate digital-wellbeing score and practical insights for improvement.',
        quote: {
            text: 'Wellbeing is central to our personal health and the health of our societies… The DQ Index provides a barometer to evaluate these competencies.',
            attribution: 'Professor Audrey Yue, Deputy Director, NUS-CTIC',
        },
        stats: [
            { value: '4,000+', label: 'people surveyed across Singapore, Seoul, Shanghai and London' },
            { value: '23', label: 'experts consulted' },
            { value: '5 domains', label: 'covering the major dimensions of everyday digital life' },
        ],
        builtWith: 'FrameworkCreator · AssessCreator',
        websiteUrl: 'https://ctic.nus.edu.sg/livingwell.html',
    },
    {
        id: 'tiktok',
        sector: 'corp',
        cats: ['Companies'],
        logo: ImpactStoryLogoTiktok,
        logoAlt: 'TikTok logo',
        hero: HomeStoryImage5,
        heroAlt: 'TikTok Family Safety Toolkit Powered by DQ',
        heroFit: 'contain',
        heroPosition: 'center center',
        logoScale: 1,
        title: 'Turning digital-safety standards into practical tools for families across Asia-Pacific',
        summary: 'As young people spent more time online during the COVID-19 pandemic, parents needed practical ways to guide their teenagers without having to become technology experts. Platform controls were available, but families also needed to understand when, why and how to use them—and how to talk openly about wider online risks. TikTok developed the TikTok Family Safety Toolkit, Powered by DQ, combining TikTok’s platform-safety features with digital-parenting guidance aligned with the DQ Framework. The toolkit translated digital citizenship principles into ten practical actions that parents and teenagers could complete together. Launched for Safer Internet Day 2021, the toolkit was made available through TikTok’s in-app Safety Center across Asia-Pacific. Publicly documented launches took place in Indonesia, Malaysia and the Philippines, supported by local education, government and youth-serving organizations including Indonesia’s Ministry of Education and Culture, JA Malaysia and JA Philippines.',
        body: 'As young people spent more time online during the COVID-19 pandemic, parents needed practical ways to guide their teenagers without having to become technology experts. Platform controls were available, but families also needed to understand when, why and how to use them—and how to talk openly about wider online risks. TikTok developed the TikTok Family Safety Toolkit, Powered by DQ, combining TikTok’s platform-safety features with digital-parenting guidance aligned with the DQ Framework. The toolkit translated digital citizenship principles into ten practical actions that parents and teenagers could complete together. Launched for Safer Internet Day 2021, the toolkit was made available through TikTok’s in-app Safety Center across Asia-Pacific. Publicly documented launches took place in Indonesia, Malaysia and the Philippines, supported by local education, government and youth-serving organizations including Indonesia’s Ministry of Education and Culture, JA Malaysia and JA Philippines.',
        quote: {
            text: 'We’re excited to partner with DQ Institute to launch the TikTok Family Safety Toolkit aligned with the DQ framework.',
            attribution: 'Arjun Narayan Bettadapur, Director, Trust & Safety, TikTok Asia Pacific',
        },
        stats: [
            { value: '3+', label: 'APEC economies with publicly documented launches' },
            { value: '10', label: 'practical digital-parenting actions for parents and teenagers' },
            { value: 'APAC', label: 'regional availability through TikTok’s Safety Center' },
        ],
        websiteUrl: 'https://www.tiktok.com/safety',
    },
    {
        id: 'esmart',
        sector: 'ngo',
        cats: ['Companies'],
        logo: ImpactStoryLogoEsmart,
        logoAlt: 'Alannah & Madeline Foundation logo',
        logo2: ImpactStoryLogo2Accenture,
        logo2Alt: 'Accenture logo',
        logoScale2: 0.9,
        hero: HomeStoryImage6,
        heroAlt: 'Alannah & Madeline Foundation eSmart Digital License+',
        heroFit: 'contain',
        title: 'eSmart Digital License+ became Australia’s leading online safety program — and won $6M in government funding to go further',
        summary: 'The Foundation needed a common measurement framework so impact could be proven and compared across programs and countries. It upgraded its Digital License with assessments based on the DQ Global Standard, Powered by DQ, with results feeding the Child Online Safety Index.',
        body: 'The Foundation needed a common measurement framework so impact could be proven and compared across programs and countries. It upgraded its Digital License with assessments based on the DQ Global Standard, Powered by DQ, with results feeding the Child Online Safety Index.',
        quote: {
            text: 'The support from Accenture and DQ Institute will enable us to bridge the digital divide which contributes to inequity in education and limits future opportunities for so many children.',
            attribution: 'Sarah Davies AM, CEO, Alannah & Madeline Foundation',
        },
        stats: [
            { value: '278,000 across 4 countries', label: 'students protected' },
            { value: '83%', label: 'demonstrated protective digital skills' },
            { value: '74%', label: 'intended to improve their online behavior' },
        ],
        builtWith: 'DQ Stars · Define, Measure, Build, Validate',
        websiteUrl: 'https://www.amf.org.au/news/6-million-in-funding-to-roll-out-new-esmart-lessons-protecting-children-online',
    },
    {
        id: 'world-bank-kyrgyz',
        sector: 'gov',
        cats: ['Governments and ministries', 'Frameworks and indices'],
        logo: ImpactStoryLogoWorldBank,
        logoAlt: 'World Bank logo',
        logo2: ImpactStoryLogo2KyrgyzMoe,
        logo2Alt: 'Kyrgyz Ministry of Education logo',
        logoScale2: 0.9,
        hero: HomeStoryImage7,
        heroAlt: 'World Bank & Kyrgyz Republic national digital-skills system',
        heroFit: 'contain',
        heroPosition: 'center center',
        title: 'From teacher training to system transformation in the Kyrgyz Republic',
        summary: 'The Kyrgyz Republic was investing in digital infrastructure for schools, but many teachers lacked the competencies and pedagogical preparation to use it effectively. Working with the World Bank, PbDQ developed a five-step methodology for building a national digital-skills system—aligning national goals, benchmarking international frameworks, comparing existing programs, designing improvements, and measuring progress. This architecture informed the country’s digital-skills assessment framework and a pilot combining an 80-hour teacher-training program with 32 weeks of mentoring. The pilot moved teachers’ digital competence from 47.5 to 52.9, advancing the group from B1 Integrator to B2 Expert on DigCompEdu.',
        body: 'The Kyrgyz Republic was investing in digital infrastructure for schools, but many teachers lacked the competencies and pedagogical preparation to use it effectively. Working with the World Bank, PbDQ developed a five-step methodology for building a national digital-skills system—aligning national goals, benchmarking international frameworks, comparing existing programs, designing improvements, and measuring progress. This architecture informed the country’s digital-skills assessment framework and a pilot combining an 80-hour teacher-training program with 32 weeks of mentoring. The pilot moved teachers’ digital competence from 47.5 to 52.9, advancing the group from B1 Integrator to B2 Expert on DigCompEdu.',
        stats: [
            { value: '36,000', label: 'teachers trained—80% women' },
            { value: '1,200', label: 'schools equipped with IT platforms' },
            { value: '141', label: 'pilot schools applied the digital-skills assessment frameworks' },
        ],
        websiteUrl: 'https://www.worldbank.org/en/results/2026/04/15/building-digital-skills-to-jobs-pathways-for-citizens-teachers-and-students-in-europe-and-central-asia',
    },
    {
        id: 'uae-moe',
        sector: 'gov',
        cats: ['Governments and ministries', 'Frameworks and indices'],
        logo: ImpactStoryLogoUaeMoe,
        logoAlt: 'UAE Ministry of Education logo',
        logoScale: 1,
        hero: HomeStoryImage8,
        heroAlt: 'UAE Ministry of Education Digital Literacy Cross-Curricular Framework',
        heroFit: 'contain',
        heroPosition: 'center center',
        title: 'Designing a K–12 digital-literacy framework connecting AI and sustainability',
        summary: 'The rapid development of generative AI created a need to prepare students not only to understand new technologies, but to use them safely, ethically, creatively and sustainably. The UAE Ministry of Education sought a coherent framework that could embed these capabilities throughout school education rather than confining them to a single technology subject. In collaboration with the DQ Institute, the Ministry developed the Digital Literacy Cross-Curricular Framework (DLCCF) through a process of consultation, review and iteration. Designed for learners from kindergarten to Grade 12, the framework translated the DQ Framework underlying IEEE 3527.1™ into age-appropriate learning outcomes that could be applied across subjects. The DLCCF brought together four connected domains: Citizenship and Protection, Information and AI Literacies, Communication and Collaboration, and the Digital Economy. It also introduced sustainability, digital wellbeing, safety, ethics and responsible AI use as connected elements of digital literacy. The result was a structured reference framework through which curriculum teams could identify digital-learning opportunities across grade levels and subjects, while connecting the UAE’s educational priorities with a globally aligned foundation.',
        body: 'The rapid development of generative AI created a need to prepare students not only to understand new technologies, but to use them safely, ethically, creatively and sustainably. The UAE Ministry of Education sought a coherent framework that could embed these capabilities throughout school education rather than confining them to a single technology subject. In collaboration with the DQ Institute, the Ministry developed the Digital Literacy Cross-Curricular Framework (DLCCF) through a process of consultation, review and iteration. Designed for learners from kindergarten to Grade 12, the framework translated the DQ Framework underlying IEEE 3527.1™ into age-appropriate learning outcomes that could be applied across subjects. The DLCCF brought together four connected domains: Citizenship and Protection, Information and AI Literacies, Communication and Collaboration, and the Digital Economy. It also introduced sustainability, digital wellbeing, safety, ethics and responsible AI use as connected elements of digital literacy. The result was a structured reference framework through which curriculum teams could identify digital-learning opportunities across grade levels and subjects, while connecting the UAE’s educational priorities with a globally aligned foundation.',
        stats: [
            { value: 'K–12', label: 'age progression covered by the framework' },
            { value: '4', label: 'connected digital-literacy domains' },
            { value: '1', label: 'cross-curricular structure linking AI literacy, responsibility and sustainability' },
        ],
        websiteUrl: 'https://moe.gov.ae/en/pages/ai.aspx',
    },
];

const TIMELINE = [
    {
        date: '2009–2016',
        color: '#68C3EE',
        h: 'The foundation',
        lead: 'The framework takes shape:',
        b: 'research-based digital citizenship education built through iZ HERO and DQ World in Korea and Singapore, then codified as Digital Intelligence and introduced through the World Economic Forum.',
    },
    {
        date: '2017–2020',
        color: '#BCD253',
        h: 'From movement to standard',
        lead: 'The framework becomes a global standard:',
        b: '#DQEveryChild reaches more than 1.5 million children across 80+ countries through 100+ partners; IEEE 3527.1™, the DQ Global Standard, is published in 2020; and the Child Online Safety Index provides countries with the first national-level measure of child online safety, contributing to discussions on measurement for the G20 digital economy.',
    },
    {
        date: 'Today',
        color: '#ED6628',
        h: 'Powered by DQ',
        lead: 'The standard becomes operational:',
        b: '1,000+ frameworks and programs at its foundation, letting anyone build a curriculum ~100× faster and at ~1% of conventional cost.',
    },
];

const PbdqImpactPageContent = () => {
    const shared = useSharedStyles();
    const classes = useStyles();
    const openAgentChat = useAgentChat();

    return (
        <div className={shared.page} style={{ background: '#FFFFFF' }}>
            <PbdqNav />
            {/* <PbdqGradientStripe sticky /> */}
            <section aria-label="Introduction" className={classes.heroSection}>
                <div className={classes.heroInner}>
                    <div className={classes.heroContent}>
                        <h1 className={classes.heroTitle}>
                            Nearly two decades setting the global agenda on <span className={classes.heroTitleHighlight}>AI-digital literacy.</span>
                        </h1>
                        <p className={classes.heroLead}>
                            Since 2009, DQ Institute has moved child online safety and AI-digital literacy from the margins to the heart of the global agenda — creating the concept, the framework, the global standard, and now the platform that turns it into action. What follows is what that has produced, and what partners have built on it.
                        </p>
                    </div>
                    <div className={classes.heroArt}>
                        <img
                            src={ImpactHero}
                            alt="Nearly two decades of impact setting the global agenda on AI-digital literacy"
                            className={classes.heroPhotoImg}
                        />
                    </div>
                </div>
            </section>

            <section aria-label="The impact at a glance" className={classes.statsSection}>
                <div className={classes.statsInner}>
                    <div className={classes.statsGrid}>
                        {STATS.map((stat, i) => (
                            <div key={stat.label} className={classes.statCell}>
                                <span className={classes.statRail} style={{ background: STAT_RAILS[i] }} aria-hidden="true" />
                                <p className={classes.statValue}>{stat.value}</p>
                                <p className={classes.statLabel}>{stat.label}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section aria-label="Stories" style={{ background: '#F4F6F9' }}>
                <PbdqImpactStories stories={STORIES} />
            </section>

            <section aria-label="Two decades of impact" className={classes.timelineSection}>
                <div className={classes.timelineInner}>
                    <div className={classes.timelineBox}>
                        <div className={classes.timelineHeader}>
                            <span className={classes.timelineKicker}>Two decades of impact</span>
                            <h2 className={classes.timelineTitle}>
                                How a standard became a <span className={classes.timelineTitleHighlight}>system</span>
                            </h2>
                        </div>
                        <div className={classes.timelineBodyRow}>
                            <ol className={classes.timelineList}>
                                {TIMELINE.map((item, idx) => {
                                    const isLast = idx === TIMELINE.length - 1;
                                    return (
                                        <li
                                            key={item.date}
                                            className={classes.timelineItem}
                                            style={{ paddingBottom: isLast ? 0 : 28 }}
                                        >
                                            <span className={classes.timelineTrackCol}>
                                                <span
                                                    className={classes.timelineDot}
                                                    style={{ background: item.color }}
                                                />
                                                {!isLast && <span className={classes.timelineLine} />}
                                            </span>
                                            <div className={classes.timelineItemContent}>
                                                <span className={classes.timelineItemDate}>{item.date}</span>
                                                <h4 className={classes.timelineItemHeading}>{item.h}</h4>
                                                <p className={classes.timelineItemDesc}>
                                                    <b className={classes.timelineItemLead}>{item.lead}</b> {item.b}
                                                </p>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ol>
                            <figure className={classes.videoFigure}>
                                <div className={classes.videoWrap}>
                                    <iframe
                                        className={classes.videoIframe}
                                        src="https://player.vimeo.com/video/1215320728?badge=0&autopause=0&autoplay=1&muted=1&loop=1&player_id=0&app_id=58479"
                                        title="Two decades of impact"
                                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                        allowFullScreen
                                    />
                                </div>
                                <figcaption className={classes.videoCaption}>
                                    This video traces Dr Yuhyun Park, the founder of DQ Institute, from pioneering iZ HERO and DQ World to advancing #DQEveryChild, IEEE 3527.1™, and Powered by DQ.
                                </figcaption>
                            </figure>
                        </div>
                    </div>
                </div>
            </section>

            <section aria-label="Next step" className={classes.ctaSection}>
                <div className={classes.ctaInner}>
                    <h3 className={classes.ctaTitle}>Build the next story on it.</h3>
                    <Link to={pbdqRoutes.pricing} className={classes.ctaBtn}>
                        Configure and get pricing
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M5 12h14" />
                            <path d="m12 5 7 7-7 7" />
                        </svg>
                    </Link>
                </div>
            </section>

            {/* <PbdqGradientStripe /> */}
            <PbdqFooter />
        </div>
    );
};

export default PbdqImpactPageContent;
